<template>
    <div>
        <ValidatedText :value="value == 'None' ? '' : value" />
    </div>
</template>
<script setup lang="ts">
import { ValidatedText } from '@/components';
import type { ExitStatus } from '@/objects/generated';

const props = defineProps<{
    /**
     * The value to display
     * @default null
     */
    value: ExitStatus;
}>();
</script>
